import axios from "axios";
import { API } from "./api";

const RESERVED = new Set(["www", "app", "prep", "api", "admin", "clinq", "static", "cdn", "status", "mail"]);
export const TENANT_BASE_DOMAIN = "clinq.africa";

// Host-based detection (prod: sidian.clinq.africa). Path-based /t/:sub is handled by routes.
export const detectHostTenant = () => {
  const host = (window.location.hostname || "").toLowerCase();
  if (!host.endsWith(`.${TENANT_BASE_DOMAIN}`)) return null;
  const sub = host.slice(0, -(TENANT_BASE_DOMAIN.length + 1));
  if (!sub || sub.includes(".") || RESERVED.has(sub)) return null;
  return sub;
};

const TOKEN_KEY = "clinq_tenant_token";
export const setTenantToken = (t) => { try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch (_) { /* noop */ } };
export const getTenantToken = () => { try { return localStorage.getItem(TOKEN_KEY) || ""; } catch (_) { return ""; } };

export const tapi = axios.create({ baseURL: API, withCredentials: false });
tapi.interceptors.request.use((config) => {
  const t = getTenantToken();
  if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  return config;
});

export const apiErr = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join("; ") || fallback;
  return d.message || fallback;
};

export const fmtKes = (v) => (v == null ? "—" : `KES ${Math.round(v).toLocaleString("en-KE")}`);

const RM_TOKEN_KEY = "clinq_tenant_rm_token";
export const setRmToken = (t) => { try { t ? localStorage.setItem(RM_TOKEN_KEY, t) : localStorage.removeItem(RM_TOKEN_KEY); } catch (_) { /* noop */ } };
export const getRmToken = () => { try { return localStorage.getItem(RM_TOKEN_KEY) || ""; } catch (_) { return ""; } };
export const rmapi = axios.create({ baseURL: API, withCredentials: false });
rmapi.interceptors.request.use((config) => {
  const t = getRmToken();
  if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  return config;
});
export const LEAD_STATUS_LABEL = { new: "New", in_progress: "In Progress", converted: "Converted", not_proceeding: "Not Proceeding" };

// Main Clinq site: prod tenants live on <sub>.clinq.africa → clinq.africa;
// path-mode previews (/t/<sub>) stay on the same origin.
export const mainSiteUrl = (path = "/") => (detectHostTenant() ? `https://${TENANT_BASE_DOMAIN}` : window.location.origin) + path;

// Ecosystem-partner sector gate answer (per tenant, per browser session).
const fitKey = (sub) => `clinq_tenant_fit_${sub}`;
export const setSectorFit = (sub, ok) => { try { sessionStorage.setItem(fitKey(sub), ok ? "yes" : "no"); } catch (_) { /* noop */ } };
export const getSectorFit = (sub) => { try { return sessionStorage.getItem(fitKey(sub)); } catch (_) { return null; } };
